export const blankHeaderPlaceholder = 'TRUSTERO_BLANK_HEADER_PLACEHOLDER'
